import { render, staticRenderFns } from "./OfaHistoryExport.vue?vue&type=template&id=46270b00&scoped=true"
import script from "./OfaHistoryExport.vue?vue&type=script&lang=js"
export * from "./OfaHistoryExport.vue?vue&type=script&lang=js"
import style0 from "./OfaHistoryExport.vue?vue&type=style&index=0&id=46270b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46270b00",
  null
  
)

export default component.exports